import React from 'react'

/**
 * Encabezado común de las pantallas del cliente (Mis talleres, Carrito…).
 * `titulo` + `destacado` arman el título con la palabra marcada en amarillo:
 *   <EncabezadoPagina titulo="Mis" destacado="talleres" />
 */
export default function EncabezadoPagina({ icon, titulo, destacado, subtitulo, children }) {
    return (
        <header className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
            <div className="flex items-center gap-4">
                {icon && (
                    <div className="relative flex-shrink-0">
                        <div className="w-14 h-14 rounded-2xl bg-primary text-white flex items-center justify-center text-2xl shadow-[0_8px_20px_-6px_rgba(0,71,187,.55)]">
                            {icon}
                        </div>
                        <span aria-hidden className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-secondary ring-4 ring-[#f4f6f9]" />
                    </div>
                )}
                <div>
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight">
                        {titulo}{destacado && <> <span className="hl-amarillo">{destacado}</span></>}
                    </h1>
                    {subtitulo && <p className="text-sm sm:text-base text-gray-500 mt-1">{subtitulo}</p>}
                </div>
            </div>
            {children && <div className="flex items-center gap-3 flex-wrap">{children}</div>}
        </header>
    )
}
